export const headerConfig = {
  headerTitle: 'Application Status',
  headerDescription: 'Shows status of Applications',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
